import type { QueryClient } from "@tanstack/react-query";
import { redirect } from "@tanstack/react-router";

import { meQuery, type User } from "@/entities/me";

export interface RouterContext {
  queryClient: QueryClient;
}

/**
 * Страница только для вошедших: без сессии — на вход с возвратом сюда
 * (`/login?next=…`, PRD S1).
 */
export async function requireUser(context: RouterContext, href: string): Promise<User> {
  const user = await context.queryClient.ensureQueryData(meQuery);
  if (!user) throw redirect({ to: "/login", search: { next: href } });
  return user;
}

/** Куда вернуть после входа: только свой путь, не чужой сайт (`//evil`, `https://…`). */
export function safeNext(next: unknown): string {
  if (typeof next !== "string" || !next.startsWith("/") || next.startsWith("//") || next.startsWith("/\\")) return "/";
  return next;
}
